module.exports = __webpack_public_path__ + "static/media/nino.7095768b.png";